export default {
  workflow: {
    title: 'Workflow',
    heading: '隐私保护工作流程',
    description: '从数据输入到验证输出的完整隐私保护流程',
    steps: {
      dataInput: {
        title: 'Data Input',
        description: '用户输入原始数据',
        label: 'Raw Data'
      },
      encryption: {
        title: 'Encryption',
        description: '数据加密处理',
        label: 'Encrypted Data'
      },
      computation: {
        title: 'Computation',
        description: '隐私保护计算',
        label: 'Secure Compute'
      },
      verification: {
        title: 'Verification',
        description: '零知识证明验证',
        label: 'ZK Proof'
      },
      output: {
        title: 'Output',
        description: '输出验证结果',
        label: 'Verified Result'
      }
    }
  },
  features: {
    title: 'Features',
    heading: '核心技术特性',
    description: '隐私保护层提供的核心功能和技术特性'
  },
  useCases: {
    title: 'Use Cases',
    heading: '应用场景',
    description: '隐私保护层在实际应用中的使用场景'
  },
  benefits: {
    title: 'Benefits',
    heading: '核心优势',
    description: '隐私保护层带来的核心价值和优势'
  },
  cta: {
    title: '开始构建隐私保护应用',
    description: '使用Titron隐私保护层，构建下一代Web3应用',
    button: '开始构建'
  }
};